import { createTheme, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, ThemeProvider } from '@mui/material';
import React, { useState } from 'react'
import { PiCurrencyDollarFill } from 'react-icons/pi';
import { GoDash } from "react-icons/go";
import { BsCloudDownload } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { PaymentAPI } from '../../api/PaymentAPI';
import { useSelector } from 'react-redux';

const theme = createTheme({
    components: {
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: '#f1f1f1',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'var(--hoverColorBold)',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: '#555',
                    }
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    color: '#000',
                    fontWeight: 'bold',
                }
            }
        }
    }
})

const columns = [
    {
        id: 'date',
        label: 'Date',
    },
    {
        id: 'status',
        label: 'Status'
    },
    {
        id: 'from',
        label: 'From'

    },
    {
        id: 'amount',
        label: 'Amount'
    },
    {
        id: 'refundStatus',
        label: 'Refunded'
    },
    {
        id: 'receipt',
        label: 'Receipt'
    }
];
const PaymentHistoryTable = ({ paymentHistories }) => {
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    };

   const downloadReceiptUrl = async (paymentIntentId) => {
    try {
        // This now returns a Blob
        const blob = await PaymentAPI.fetchReceiptUrl(
            userInfo.userId, 
            selectedClub.clubId, 
            paymentIntentId
        );
        
        console.log('PDF Blob size:', blob.size);
        console.log('PDF Blob type:', blob.type);
        
        // Validate the blob
        if (blob.size === 0) {
            throw new Error('Received empty PDF');
        }
        
        // Create download link
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `receipt-${paymentIntentId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Clean up
        setTimeout(() => {
            window.URL.revokeObjectURL(downloadUrl);
        }, 100);
        
    } catch (error) {
        console.error("Error downloading receipt:", error);
        
        // Check if it's an error response from the server
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.error('Server error:', error.response.status);
            alert(`Server error: ${error.response.status}`);
        } else if (error.request) {
            // The request was made but no response was received
            console.error('No response from server');
            alert('No response from server. Please check your connection.');
        } else {
            // Something happened in setting up the request that triggered an Error
            alert(`Failed to download receipt: ${error.message}`);
        }
    }
};

    return (
        <div data-testid="billing_payment_history" className='billing_payment_history'>

            <ThemeProvider theme={theme}>
                <Paper sx={{ width: '100%', overflow: 'hidden', boxShadow: 0, borderRadius: 3 }}>
                    <TableContainer sx={{ maxHeight: 440 }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {columns.map((column) => (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            style={{ minWidth: column.minWidth }}
                                        >
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paymentHistories
                                    .map((row) => {
                                        return (
                                            <TableRow data-testid="payment-history-table-body" hover role="checkbox" tabIndex={-1} key={row.code}>
                                                <TableCell>{new Date(row.date).toLocaleString("en-US", options)}</TableCell>
                                                <TableCell>
                                                    {row.status === 'succeeded' &&
                                                        <div className='user_pay_history_status succeeded'>
                                                            <span class="r-status succeeded">{row.status}</span>
                                                        </div>}
                                                    {row.status === 'processing' &&
                                                        <div className='user_pay_history_status processing'>
                                                            <span class="r-status processing">{row.status}</span>
                                                        </div>}
                                                    {row.status === 'canceled' &&
                                                        <div className='user_pay_history_status canceled'>
                                                            <span class="r-status canceled">{row.status}</span>
                                                        </div>}
                                                </TableCell>
                                                <TableCell>{row.from}</TableCell>
                                                <TableCell>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <PiCurrencyDollarFill className="reservation_amount_incon_reserved" />{Number(row.amount).toFixed(2)}
                                                    </div>

                                                </TableCell>
                                                <TableCell>
                                                    <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                                                        {row.refundStatus === '0' && <GoDash />}
                                                        {row.refundStatus !== '0' &&
                                                            <>
                                                                <PiCurrencyDollarFill className="reservation_amount_incon_reserved" />{Number(row.refundStatus).toFixed(2)}
                                                            </>}
                                                    </div>
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Link className='pdf_dowload_btn' onClick={() => downloadReceiptUrl(row.paymentIntentId)}>
                                                        <BsCloudDownload className='pdf_dowload_icon' />Download
                                                    </Link>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </ThemeProvider>
        </div>
    )
}

export default PaymentHistoryTable